import {CommunityCollegeInfo, CurrentInstitution, HighSchoolInfo} from 'src/types/education';
import {Student} from 'src/types/store';
import {Portfolio} from 'src/types/user';

export interface StudentResume {
  name: string;
  contactInformation: string;
  intendedMajor?: string;
  academicInterests: string[];
  currentInstitution: CurrentInstitution;
  communityCollegeInfo?: CommunityCollegeInfo;
  highSchoolInfo?: HighSchoolInfo;
  portfolio: Portfolio;
}

/**
 * Provides a consistent shape for student objects for the resume components
 */
export default function formatStudentForResume(student: Student): StudentResume {
  const residentState = student.state ? student.state : student.subdivision;
  const academicInterests = student.academicInterests ? student.academicInterests : [];
  return {
    name: `${student.firstName} ${student.lastName}`,
    contactInformation: `${student.email} | ${student.city}, ${residentState}`,
    intendedMajor: student.communityCollegeInfo
      ? student.communityCollegeInfo.intendedMajor
      : undefined,
    academicInterests: academicInterests
      ? academicInterests.map((interest) => interest['displayName'] || interest.name)
      : [],
    currentInstitution: student.currentInstitution as unknown as CurrentInstitution,
    communityCollegeInfo: student.communityCollegeInfo as unknown as CommunityCollegeInfo,
    highSchoolInfo: student.highSchoolInfo as unknown as HighSchoolInfo,
    portfolio: student.portfolio as unknown as Portfolio,
  };
}
